import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
    inject,
    output,
    DestroyRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FiDndDetails, FiDndHelper } from '@fi-shared/fi-insert-media/fi-dnd-overlay/fi-dnd-helper';
import { FiFileUpload2Service } from '@fi-shared/fi-insert-media/fi-file-upload2.service';
import { FileType } from '@fi-shared/types';

@Component({
    selector: 'fi-dnd-overlay',
    template: `
        <div class="fi-dnd-overlay-main-container">
            <div class="fi-dnd-overlay-icons-container" #iconsContainer>
                <i [ngClass]="leftIconClassName" class="dnd-left-icon red"></i>
                <i [ngClass]="centerIconClassName" class="dnd-center-icon orange"></i>
                <i [ngClass]="rightIconClassName" class="dnd-right-icon blue"></i>
            </div>
            @if (isTextShown) {
                <div class="fi-dnd-overlay-text-container">
                    <p class="text">{{ textId | fiAppText }}</p>
                </div>
            }
        </div>
    `,
    styleUrls: ['./fi-dnd-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-dnd-overlay' },
    standalone: false,
})
export class FiDndOverlayComponent implements OnInit {
    @Input() leftIconClassName: string = 'far fa-file-pdf';
    @Input() centerIconClassName: string = 'fas fa-photo-video';
    @Input() rightIconClassName: string = 'fas fa-cloud-download-alt';
    @Input() iconsSize: number = 65;
    @Input() isTextShown: boolean = true;
    @Input() textId: string = 'ccmFileUpload.dropFilesMultipleInstantly';
    @Input() parentElementRef: ElementRef;
    @Input() isExtractFilesPrevent: boolean = false;
    @Input() fileTypes: FileType[];
    @ViewChild('iconsContainer', { static: true }) iconsContainer: ElementRef;
    public uploadFiles = output<File[]>();
    public dndDetails = output<FiDndDetails>();

    fiDndHelper = new FiDndHelper();
    private readonly overlayHiddenClassName = 'overlay-hidden';

    private renderer = inject(Renderer2);
    private elementRef = inject(ElementRef);
    private fileUpload2Service = inject(FiFileUpload2Service);
    private destroyRef = inject(DestroyRef);

    public ngOnInit(): void {
        this.setIconsSize();
        this.setDndSubscriptions();
    }

    private setDndSubscriptions(): void {
        this.fiDndHelper.initDndEventSubscriptions(this.parentElementRef, this.fileUpload2Service, {
            allowedFileTypes: this.fileTypes,
        });
        this.fiDndHelper.dragging$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isDragging) => {
            if (isDragging) {
                this.renderer.removeClass(this.elementRef.nativeElement, this.overlayHiddenClassName);
            } else {
                this.renderer.addClass(this.elementRef.nativeElement, this.overlayHiddenClassName);
            }
        });
        this.fiDndHelper.onDropping$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event: DragEvent) => {
            if (!this.isExtractFilesPrevent) {
                this.fileUpload2Service
                    .extractFilesFromDrop(event.dataTransfer, event.dataTransfer.files)
                    .then((result) => {
                        this.uploadFiles.emit(result);
                    });
            }
        });

        this.fiDndHelper.onDndDetails$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((dndDetails) => {
            this.dndDetails.emit(dndDetails);
        });
    }

    private setIconsSize(): void {
        this.renderer.setStyle(this.iconsContainer.nativeElement, 'font-size', `${this.iconsSize}px`);
    }

    // protected getLeftIconClass(): string {
    //     return this.leftIconClassName;
    // }

    // protected getCenterIconClass(): string {
    //     return this.centerIconClassName;
    // }

    // protected getRightIconClass(): string {
    //     return this.rightIconClassName;
    // }
}
